import React from "react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface OrganizationErrorAlertProps {
  organizationError: string | null;
  onSetupOrganization: () => void;
}

export const OrganizationErrorAlert: React.FC<OrganizationErrorAlertProps> = ({
  organizationError,
  onSetupOrganization,
}) => {
  if (!organizationError) return null;

  return (
    <Alert className="mb-6">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Organization Setup Required</AlertTitle>
      <AlertDescription className="flex flex-col gap-2">
        <span>{organizationError}</span>
        <Button onClick={onSetupOrganization} size="sm" className="w-fit">
          Set up organization
        </Button>
      </AlertDescription>
    </Alert>
  );
};
